import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11b17742"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__transcription" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "form__title" }, "Redefinição de senha"),
  /*#__PURE__*/_createElementVNode("p", { class: "form__description" }, [
    /*#__PURE__*/_createTextVNode(" Esqueceu sua senha? "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Digite seu CPF o E-mail para que possamos dar continuidade na recuperação de senha. ")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  form: "reset-password",
  class: "form__input--submit",
  type: "submit"
}, " Enviar ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"])),
    id: "reset-password",
    class: "form"
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      "data-input": "",
      id: "login-email",
      type: "text",
      form: "reset-password",
      class: "form__input",
      placeholder: "CPF ou e-mail",
      autocomplete: "off",
      maxlength: "254",
      required: "",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userData.document) = $event)),
      onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.unmaskCPF && $setup.unmaskCPF(...args))),
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.maskCPF && $setup.maskCPF(...args)))
    }, null, 544), [
      [_directive_focus],
      [_vModelText, $setup.userData.document]
    ]),
    _hoisted_2
  ], 32))
}